module.exports = __webpack_public_path__ + "videos/video-768.e71865e.webm";